import React from 'react';
import { motion } from "framer-motion";
import SocialButton from '../Social/SocialButton';
import Data from '../../Data';

const SocialButtons = () => {
    return (
        <motion.div
            exit={{ opacity: 0 }}
            transition={{ delay: 1.5, duration: 0.5 }}
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
        >
            <SocialButton
                social="instagram"
                icon="instagram"
                link={`https://www.instagram.com/${Data.social.instagram}`}
            />
            <SocialButton
                social="youtube"
                icon="youtube"
                link={`https://www.youtube.com/@${Data.social.youtube}`}
                margin={1}
            />
            <SocialButton
                social="facebook"
                icon="facebook-f"
                link={`https://www.facebook.com/${Data.social.facebook}`}
            />
        </motion.div>
    );
}

export default SocialButtons;
